import 'babel-polyfill';
import { createApp } from 'vue';
import App from './App.vue';
import router from './router/index.ts';
import animated from 'animate.css';
import 'amfe-flexible';
import 'amfe-flexible/index.js'
// import './assets/rem.js';
const Vue = createApp(App)
Vue.use(animated);
Vue.use(router);
Vue.mount('#app')
